module.exports = __webpack_public_path__ + "media/eyezen-start_smartphone.9ac43710.mp4";